export default __webpack_public_path__ + "static/costume_m-2a8bdf117a2601e028620baf141e0e16.png";